import CardItem from 'txp-data/lib/schema/viewSchema/CardItem';
import ActivityType from 'txp-data/lib/schema/innerSchema/ActivityType';

/**
 * Today we display phone number only for dining and service reservation
 */
export default function getTxpTelephoneNumber(cardItem: CardItem): string {
    const { activityType, detailsData } = cardItem;

    if (detailsData) {
        switch (activityType) {
            case ActivityType.Dining:
                return detailsData.thirdLine && detailsData.thirdLine.text;
            case ActivityType.ServiceAppointment:
                return detailsData.thirdLine && detailsData.thirdLine.text;
            case ActivityType.HotelCheckin:
                return detailsData.thirdLine && detailsData.thirdLine.text;
            case ActivityType.HotelCheckout:
                return detailsData.thirdLine && detailsData.thirdLine.text;
        }
    }
    return null;
}
